// extracted by mini-css-extract-plugin
export var cardContainer = "_p6-0";
export var cardHeader = "_p6-2";
export var collapsedState = "_p6-3";
export var dragHandle = "_p6-5";
export var dragHandleIcon = "_p6-6";
export var dragging = "_p6-1";
export var titleArea = "_p6-4";